import React from 'react';
import { withTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';

import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';

class MarginsFilter extends React.Component {
	constructor(props) {
		super(props);

		this.handleCheckboxChangeByMargin = this.handleCheckboxChangeByMargin.bind(this);
		this.handleMarginOnlyClick = this.handleMarginOnlyClick.bind(this);
		this.handleResetMarginsClick = this.handleResetMarginsClick.bind(this);
	}

	handleCheckboxChangeByMargin = (event, isInputChecked, margin) => {
		const { profile, t } = this.props;

		event.persist();
		FiltersActions.filterByMargin(margin, isInputChecked);
		setTimeout(() => {
			FiltersActions.filterByMargin(margin, isInputChecked);
		}, 10);

		const filter_value = t(isInputChecked ? 'FilterByMargin' : 'DontFilterByMargin', { margin });
		Analytics.actions.interactions.filteredResults(profile, FiltersConstants.FILTER_METHOD.MARGIN, filter_value);
	};

	handleMarginOnlyClick = (event) => {
		const { profile, t } = this.props;

		event.persist();
		let margin_only = event.target.getAttribute('data-margin');
		FiltersActions.filterByMarginOnly(margin_only);
		setTimeout(() => {
			FiltersActions.filterByMarginOnly(margin_only);
		}, 10);

		const filter_value = t('ShowOnlyMargin', { margin: margin_only });
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.MARGIN_ONLY,
			filter_value,
		);
	};

	handleResetMarginsClick = (event) => {
		const { profile, t } = this.props;

		event.persist();
		FiltersActions.resetMarginsFilter();
		setTimeout(FiltersActions.resetMarginsFilter, 10);

		const filter_value = t('ResetMarginsFilter');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.RESET_MARGINS_FILTER,
			filter_value,
		);
	};

	render() {
		const { t } = this.props;
		const data = this.props.filter;
		const multiple_margins = Object.keys(data).length > 1;

		const MARGINS = [];
		for (let margin in data) {
			const margin_key = margin.toLowerCase().replace(' ', '-');
			MARGINS.push(
				<div className="checkbox-container" key={margin_key}>
					<FilterCheckboxWithLabel
						checked={data[margin]}
						category={margin}
						label={margin}
						onChange={(e, c, margin) => this.handleCheckboxChangeByMargin(e, c, margin)}
					/>
					{multiple_margins ? (
						<button
							className="btn btn-link"
							data-margin={margin}
							onClick={this.handleMarginOnlyClick}
							aria-label={t('SelectOnly', { category: margin })}
						>
							{t('Only')}
						</button>
					) : null}
				</div>,
			);
		}

		return (
			<div className="filter disabled">
				<label className="filter-title" htmlFor="margins-filter">
					{t('Margins')}
				</label>
				<div name="margins-filter" className="check-list">
					{MARGINS}
				</div>
				{MARGINS.length > 1 ? (
					<button
						className="clear-button-wrap"
						onClick={this.handleResetMarginsClick}
						aria-label={t('ResetMarginsFilter')}
					>
						<div className="clear-button-img" />
					</button>
				) : null}
			</div>
		);
	}
}

export default withTranslation()(MarginsFilter);
